import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

// @utility
import validateInput from "@utility/app/validateInput";
import { trackPageView, trackEvent } from "@utility/app/analytics";

// Redux & Action
import { useDispatch } from 'react-redux';
import { rememberPassword } from "@core/redux/actions/auth/index";

// Component
import Grid from '@mui/material/Grid';
// import BackButton from "./../../components/BackButton";

// Icon
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PhoneIcon from '@mui/icons-material/Phone';

export default function RememberApp({ switchChanel }) {
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm();
    const dispatch = useDispatch();

    useEffect(() => {
        trackPageView("forgot_password_page", {
            page_group: "authentication"
        });
    }, []);

    useEffect(() => {
        if (errors.username) {
            trackEvent("forgot_password_validation_error", {
                entry_page: "forgot_password",
                field: "username",
                error_type: errors.username.type
            });
        }
    }, [errors.username]);

    const onSubmit = (data) => {
        trackEvent("forgot_password_submit_click", {
            entry_page: "forgot_password"
        });
        dispatch(rememberPassword(data, switchChanel));
    };

    const renderErrorUsername = () => {
        if (!errors.username) return null;

        return (
            <div className="validateError">
                {errors.username.message || "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง"}
            </div>
        );
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="inputPaddingTop">
                <br />
                <div className="boxTitle" style={{ color: "var(--bg-white)" }}>
                    ลืมรหัสผ่าน ?
                </div>
                <div className="inputPaddingTop">
                    <div className="inputTextLabel">
                        เบอร์โทรศัพท์
                    </div>
                    <Grid container alignItems="center" className="inputStyles center">
                        <Grid item xs={2}>
                            <PhoneIcon className="iconSize" />
                        </Grid>
                        <Grid item xs={10}>
                            <input
                                type="tel"
                                inputMode="numeric"
                                className="inputStyles inputStylesBorderNone" 
                                placeholder="เบอร์โทรศัพท์"
                                maxLength={10}
                                {...register("username", {
                                    required: "กรุณากรอกเบอร์โทรศัพท์",
                                    minLength: {
                                        value: 10,
                                        message: "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก"
                                    },
                                    maxLength: {
                                        value: 10,
                                        message: "กรุณากรอกเบอร์โทรศัพท์ไม่เกิน 10 หลัก"
                                    },
                                    pattern: {
                                        value: /^[0-9]+$/,
                                        message: "เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น (0–9)"
                                    }
                                })}
                                onKeyDown={(event) => validateInput(event, "number")}
                                onPaste={(event) => validateInput(event, "number")}
                            />
                        </Grid>
                    </Grid>
                    {
                        renderErrorUsername()
                    }
                </div>
            </div>

            <br />
            <div className="center">
                <div className="inputPaddingTop">
                    <button type="submit" className="btn btnConfirm btnHover btnWidthLarge btnRadius textBoldHight">
                        ขอรหัสผ่านใหม่
                    </button>
                </div>
            </div>
        </form>
    );
}